import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { WalletService } from '../services/wallet.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';

@Component({
  selector: 'app-airtelcms',
  templateUrl: './airtelcms.component.html',
  styleUrls: ['./airtelcms.component.scss']
})
export class AirtelcmsComponent implements OnInit {
  aepsCWForm: FormGroup;
  lat;
  lng;
  zoom;

  constructor(private formBuilder:FormBuilder, private auth: WalletService,private ngx: NgxUiLoaderService, private route:Router,   private toast: ToastrService,
  ) {
    this.aepsCWForm = this.formBuilder.group({
      refid: ['', Validators.required],   
    });
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(position => {
        this.lat = position.coords.latitude;
        this.lng = position.coords.longitude;
        this.zoom = 16;
        this.submit()

       
      });
    }

   }

  ngOnInit(): void {
    this.ngx.start();

  }


  submit(){
    this.ngx.start();

   
      this.auth
      .createAirtelCMS(
        this.lat,
        this.lng
      )
      .subscribe(
        (res: any) => {
          console.log(res)
          this.route.navigate(['/dashboard'])
              const secondURL = `${res.object}`;
      window.open(secondURL, '_blank');
            if(res.status_code==1){
              this.ngx.stop();

            }
          // this.toast.success(res.msg);
          // this.requestMoney.reset();

        },
        (err) => {
          this.ngx.stop();
          this.toast.error(err.error.message);
        }
      );
  
  }
 
}
